var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.796 7.18204L10.7355 6.12154L3.75 13.107V14.1675H4.8105L11.796 7.18204ZM12.8565 6.12154L13.917 5.06104L12.8565 4.00054L11.796 5.06104L12.8565 6.12154ZM5.4315 15.6675H2.25V12.4853L12.3263 2.40904C12.4669 2.26844 12.6576 2.18945 12.8565 2.18945C13.0554 2.18945 13.2461 2.26844 13.3868 2.40904L15.5085 4.53079C15.6491 4.67144 15.7281 4.86217 15.7281 5.06104C15.7281 5.25992 15.6491 5.45065 15.5085 5.59129L5.4315 15.6675Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAddress);
export default __webpack_public_path__ + "static/media/editAddress.dea2b8a12c3b5ba5cd5ac2859670a162.svg";
export { ForwardRef as ReactComponent };